import { SearchProps } from '../../components/SearchForm';
import useMemberSearchSuggestions from './useMemberSearchSuggestions';

// The header search config shared by the members work list and the member
// detail pages, so both surfaces look up members the same way. Detail pages add
// `searchTo` on top to turn it into a jump-to control.
const memberSearchProps: Pick<SearchProps, 'searchLabel' | 'useSearchSuggestions'> = {
    searchLabel: 'Search members',
    useSearchSuggestions: useMemberSearchSuggestions
};

export default memberSearchProps;
